exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 768px) {\n    .elGnN9YL6k1gcNEgpAiSm {\n        --content-padding: 60px;\n    }\n}\n", ""]);

// exports
exports.locals = {
	"root": "elGnN9YL6k1gcNEgpAiSm"
};